<template>
  <div class="homepage">
    <AppHeroSlider banner-slug="main" />

    <!-- MOŻE CIĘ ZAINTERESOWAĆ -->
    <section class="home-section" v-if="featured.length">
      <div class="section-head">
        <h2>{{ t.home?.featured_title }}</h2>
        <router-link to="/category" class="see-all">{{ t.home?.see_all }} →</router-link>
      </div>
      <div class="rail-wrap">
        <button class="rail-btn left" @click="scroll('featured',-1)">&#8249;</button>
        <div class="rail" ref="railFeatured">
          <router-link v-for="p in featured" :key="p.id" :to="`/product/${p.slug}`" class="pcm">
            <div class="pcm-img">
              <img
                :src="p.get_image||p.get_thumbnail"
                :data-hover="p.images && p.images[0] ? p.images[0].image_url : ''"
                :alt="p.name"
                loading="lazy"
                @mouseenter="swapImg($event, p)"
                @mouseleave="restoreImg($event, p)"
              />
              <span v-if="getSale(p)" class="pcm-badge sale">SALE</span>
            </div>
            <div class="pcm-body">
              <div class="pcm-name">{{ p.name }}</div>
              <div class="pcm-prices">
                <span v-if="getSale(p)" class="pcm-sale">{{ getSale(p) }} {{ currSymbol }}</span>
                <span :class="getSale(p) ? 'pcm-old' : 'pcm-price'">{{ getPrice(p) }} {{ currSymbol }}</span>
              </div>
            </div>
          </router-link>
        </div>
        <button class="rail-btn right" @click="scroll('featured',1)">&#8250;</button>
      </div>
    </section>

    <!-- O NAS -->
    <section class="about-section">
      <div class="about-inner">
        <div class="about-left">
          <div class="about-tagline">{{ t.home?.about_tagline }}</div>
        </div>
        <div class="about-right">
          <h2>{{ t.home?.about_title }}</h2>
          <p>{{ t.home?.about_text }}</p>
          <router-link to="/kontakt" class="about-btn">Skontaktuj się →</router-link>
        </div>
      </div>
    </section>

    <!-- NOWOŚCI -->
    <section class="home-section" v-if="newest.length">
      <div class="section-head">
        <h2>{{ t.home?.new_title }}</h2>
        <router-link to="/category" class="see-all">{{ t.home?.see_all }} →</router-link>
      </div>
      <div class="rail-wrap">
        <button class="rail-btn left" @click="scroll('newest',-1)">&#8249;</button>
        <div class="rail" ref="railNewest">
          <router-link v-for="p in newest" :key="p.id" :to="`/product/${p.slug}`" class="pcm">
            <div class="pcm-img">
              <img :src="p.get_image||p.get_thumbnail" :alt="p.name" loading="lazy"/>
            </div>
            <div class="pcm-body">
              <div class="pcm-name">{{ p.name }}</div>
              <div class="pcm-prices">
                <span v-if="getSale(p)" class="pcm-sale">{{ getSale(p) }} {{ currSymbol }}</span>
                <span :class="getSale(p) ? 'pcm-old' : 'pcm-price'">{{ getPrice(p) }} {{ currSymbol }}</span>
              </div>
            </div>
          </router-link>
        </div>
        <button class="rail-btn right" @click="scroll('newest',1)">&#8250;</button>
      </div>
    </section>

    <!-- BLOG - przewijany rail -->
    <section class="home-section" v-if="blogPosts.length">
      <div class="section-head">
        <h2>{{ t.home?.blog_title }}</h2>
      </div>
      <div class="rail-wrap">
        <button class="rail-btn left" @click="scroll('blog',-1)">&#8249;</button>
        <div class="rail rail-blog" ref="railBlog">
          <router-link v-for="post in blogPosts" :key="post.id" :to="`/blog/${post.slug}`" class="blog-card">
            <div class="blog-img">
              <img :src="post.image_url" :alt="post.title" loading="lazy"/>
              <span v-if="post.category" class="blog-cat">{{ post.category }}</span>
            </div>
            <div class="blog-body">
              <div class="blog-title">{{ post.title }}</div>
              <div class="blog-excerpt">{{ post.excerpt }}</div>
              <span class="blog-read">{{ t.home?.blog_read_more }} →</span>
            </div>
          </router-link>
        </div>
        <button class="rail-btn right" @click="scroll('blog',1)">&#8250;</button>
      </div>
    </section>
  </div>
</template>

<script>
import AppHeroSlider from '@/components/AppHeroSlider.vue'
import { translations, currentLang } from '@/locales/lang'
import { currentCurrency } from '@/composables/currency'

const SYM = {PLN:'zł',EUR:'€',USD:'$',CZK:'Kč',HUF:'Ft',BGN:'лв',RON:'lei',DKK:'kr.',SEK:'kr'}

export default {
  name: 'AppCategoryList',
  components: { AppHeroSlider },
  data() { return { featured:[], newest:[], blogPosts:[] } },
  computed: {
    t() { return translations.value },
    currSymbol() { return SYM[currentCurrency.value] || currentCurrency.value },
  },
  async mounted() {
    window.addEventListener('languageChanged', this.loadAll)
    window.addEventListener('currencyChanged', this.loadAll)
    await this.loadAll()
  },
  beforeUnmount() {
    window.removeEventListener('languageChanged', this.loadAll)
    window.removeEventListener('currencyChanged', this.loadAll)
  },
  methods: {
    async loadAll() {
      await Promise.all([this.loadFeatured(), this.loadBlog()])
    },
    async loadFeatured() {
      try {
        const r = await fetch('/api/v1/latest-products/', {headers:{'Accept-Language':currentLang.value}})
        const d = await r.json()
        const all = Array.isArray(d) ? d : []
        this.featured = all.slice(0,10)
        this.newest   = [...all].reverse().slice(0,10)
      } catch(e) { console.error(e) }
    },
    async loadBlog() {
      try {
        const r = await fetch('/api/v1/blog/')
        if (!r.ok) return
        const d = await r.json()
        this.blogPosts = (Array.isArray(d)?d:d.results||[]).slice(0,6)
      } catch(e) {}
    },
    getPrice(p) {
      const k = `price_${(currentCurrency.value||'PLN').toLowerCase()}`
      const v = Number(p[k]||p.price||0)
      return isNaN(v)?'0.00':v.toFixed(2)
    },
    getSale(p) {
      const k = `sale_price_${(currentCurrency.value||'PLN').toLowerCase()}`
      const v = Number(p[k])
      return (!isNaN(v)&&v>0) ? v.toFixed(2) : null
    },
    swapImg(e, p) {
      const imgs = p.images && p.images[0] ? p.images[0].image_url : null
      if (!imgs) return
      e.target._orig = e.target.src
      e.target.style.transition = 'opacity 0.25s'
      e.target.style.opacity = '0'
      setTimeout(() => { if(e.target) { e.target.src = imgs; e.target.style.opacity = '1' } }, 130)
    },
    restoreImg(e, p) {
      if (!e.target._orig) return
      e.target.style.transition = 'opacity 0.25s'
      e.target.style.opacity = '0'
      setTimeout(() => { if(e.target) { e.target.src = e.target._orig; e.target.style.opacity = '1' } }, 130)
    },
    startAutoSwap(el, p) {
      if (!p.images || !p.images[0]) return
      el._orig = el.src
      el._swapped = false
      el._timer = setInterval(() => {
        el.style.transition = 'opacity 0.3s'
        el.style.opacity = '0'
        setTimeout(() => {
          if (!el) return
          el.src = el._swapped ? el._orig : p.images[0].image_url
          el._swapped = !el._swapped
          el.style.opacity = '1'
        }, 150)
      }, 2000)
    },
    stopAutoSwap(el) {
      if (el._timer) { clearInterval(el._timer); el._timer = null }
      if (el._orig) {
        el.style.transition = 'opacity 0.3s'
        el.style.opacity = '0'
        setTimeout(() => { if(el) { el.src = el._orig; el.style.opacity = '1' } }, 150)
      }
    },
    scroll(which, dir) {
      const refs = {featured: this.$refs.railFeatured, newest: this.$refs.railNewest, blog: this.$refs.railBlog}
      const el = refs[which]
      if (!el) return
      const item = el.querySelector('.pcm, .blog-card')
      el.scrollBy({left: dir*(item?item.offsetWidth+16:300)*2, behavior:'smooth'})
    },
  }
}
</script>

<style scoped>
.homepage {}
.home-section { max-width:1400px; margin:48px auto; padding:0 20px; }
.section-head { display:flex; align-items:center; justify-content:space-between; margin-bottom:24px; }
.section-head h2 { font-size:clamp(1.3rem,2.2vw,1.8rem); font-weight:800; margin:0; }
.see-all { font-size:.85rem; font-weight:700; color:#b07d4a; text-decoration:none; }
.see-all:hover { text-decoration:underline; }

.rail-wrap { position:relative; padding:0 4px; }
.rail {
  display:grid; grid-auto-flow:column; grid-auto-columns:minmax(200px,250px);
  gap:16px; overflow-x:auto; scroll-snap-type:x mandatory;
  padding:4px 2px 12px; -webkit-overflow-scrolling:touch; scrollbar-width:none;
}
.rail-blog { grid-auto-columns:minmax(260px,320px); }
.rail::-webkit-scrollbar { display:none; }
.rail-btn {
  position:absolute; top:40%; transform:translateY(-50%); z-index:2;
  width:40px; height:40px; border-radius:50%;
  background:#fff; border:1px solid #e5e7eb;
  box-shadow:0 2px 12px rgba(0,0,0,.1);
  font-size:22px; cursor:pointer; display:grid; place-items:center;
}
.rail-btn.left  { left:-20px; }
.rail-btn.right { right:-20px; }

/* Product card */
.pcm { scroll-snap-align:start; border:1px solid #eee; border-radius:12px; overflow:hidden; text-decoration:none; color:inherit; background:#fff; transition:box-shadow .15s,transform .15s; display:flex; flex-direction:column; }
.pcm:hover { box-shadow:0 8px 20px rgba(0,0,0,.08); transform:translateY(-2px); }
.pcm-img { position:relative; aspect-ratio:1/1; background:#f7f7f7; overflow:hidden; }
.pcm-img img { width:100%; height:100%; object-fit:cover; transition:transform .3s; }
.pcm:hover .pcm-img img { transform:scale(1.04); }
.pcm-badge { position:absolute; top:8px; right:8px; font-size:.68rem; font-weight:800; padding:3px 8px; border-radius:9999px; color:#fff; }
.pcm-badge.sale { background:#e63946; }
.pcm-body { padding:10px 12px 14px; }
.pcm-name { font-size:.88rem; font-weight:700; line-height:1.35; margin-bottom:6px; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
.pcm-prices { display:flex; align-items:center; gap:6px; flex-wrap:wrap; }
.pcm-price { font-size:.95rem; font-weight:800; color:#111; }
.pcm-sale  { font-size:.95rem; font-weight:800; color:#e63946; }
.pcm-old   { font-size:.8rem; color:#aaa; text-decoration:line-through; }

/* Blog card */
.blog-card { scroll-snap-align:start; border:1px solid #eee; border-radius:12px; overflow:hidden; text-decoration:none; color:inherit; background:#fff; transition:box-shadow .15s,transform .15s; display:flex; flex-direction:column; }
.blog-card:hover { box-shadow:0 8px 20px rgba(0,0,0,.08); transform:translateY(-2px); }
.blog-img { position:relative; aspect-ratio:16/9; overflow:hidden; background:#f5f5f5; }
.blog-img img { width:100%; height:100%; object-fit:cover; }
.blog-cat { position:absolute; top:10px; left:10px; background:#b07d4a; color:#fff; font-size:.72rem; font-weight:700; padding:3px 10px; border-radius:9999px; }
.blog-body { padding:14px; display:flex; flex-direction:column; gap:6px; }
.blog-title { font-size:.95rem; font-weight:700; line-height:1.35; }
.blog-excerpt { font-size:.82rem; color:#666; line-height:1.5; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; }
.blog-read { font-size:.82rem; font-weight:700; color:#b07d4a; margin-top:4px; }

/* About */
.about-section { background:#f7f4ef; padding:56px 20px; margin:48px 0; }
.about-inner { max-width:1100px; margin:0 auto; display:grid; grid-template-columns:1fr 1fr; gap:60px; align-items:center; }
.about-tagline { font-size:clamp(1.6rem,3.5vw,2.6rem); font-weight:900; color:#111; line-height:1.2; letter-spacing:-.02em; }
.about-right h2 { font-size:1.3rem; font-weight:800; margin:0 0 12px; }
.about-right p { font-size:.95rem; color:#666; line-height:1.75; margin:0 0 20px; }
.about-btn { display:inline-block; padding:11px 24px; background:#111; color:#fff; border-radius:9999px; font-size:.85rem; font-weight:700; text-decoration:none; }
.about-btn:hover { background:#333; }

@media(max-width:900px) { .about-inner { grid-template-columns:1fr; gap:28px; } }
@media(max-width:640px) { .rail-btn { display:none; } .home-section { margin:32px auto; padding:0 12px; } }
</style>
